import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMeta } from "../../../store/actions/metaAction";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { checkPermissions } from "../../../helpers/authentication/checkPermissions";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import Loader from "../../../components/shared/Loader";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";

const CoastsIndex = () => {
	const [coasts, setCoasts] = useState([]);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تكاليف الخدمات",
				breadcrumb: "الخدمات",
				button: {
					permissions: ["post-create"],
					show: true,
					text: "اضافة تكلفة جديد",
					link: "/coasts/create",
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/costs`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setCoasts(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const columns = [
		{
			name: "من",
			selector: "from",
			sortable: true,
			cell: row => row.cost_range.from,
		},
		{
			name: "الى",
			selector: "to",
			sortable: true,
			cell: row => row.cost_range.to,
		},
		{
			name: "",
			selector: "settings",
			cell: row => (
				<ul className="list-inline settingsList">
					{checkPermissions(["post-edit"]) && (
						<li className="list-inline-item">
							<Link
								className="bt bt-sm bt-success"
								to={`/coasts/show/${row.id}`}
							>
								<i className="fas fa-edit"></i>
							</Link>
						</li>
					)}
					{checkPermissions(["post-delete"]) && (
						<li className="list-inline-item">
							<button
								className="bt bt-sm bt-danger"
								onClick={() => handleConfrimDelete(row.id)}
								aria-label="حذف"
							>
								<i className="fas fa-trash"></i>
							</button>
						</li>
					)}
				</ul>
			),
		},
	];

	const handleConfrimDelete = coastID => {
		confirmAlert({
			title: "تأكيد الحذف",
			message: "هل أنت متأكد من رغبتك في الحذف؟",
			buttons: [
				{
					label: "نعم",
					onClick: () => deleteCoast(coastID),
				},
				{
					label: "لا",
					onClick: () => console.log("No"),
				},
			],
		});
	};

	const deleteCoast = coastID => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/costs/${coastID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="datatable">
				<DataTableExtensions columns={columns} data={coasts}>
					<DataTable
						noHeader
						defaultSortField="id"
						defaultSortAsc={false}
						pagination
						highlightOnHover
						direction="rtl"
						striped
					/>
				</DataTableExtensions>
			</div>
		</section>
	);
};

export default CoastsIndex;
